module.exports = __webpack_public_path__ + "img/icon_renenue.973d1d31.png";